import React from 'react'
import { withRef } from '@udecode/cn'
import { PlateElement } from '@udecode/plate-common/react'

import { typeaheadMenuWrapperHidden } from './Typeahead/Typeahead.css'
import { getTriggerBehavior } from './helpers'
import { InlineCombobox, InlineComboboxContent, InlineComboboxInput } from './InlineCombobox'
import { ComboboxContainerProps } from './types'

export const ComboboxContainer = withRef<typeof PlateElement, ComboboxContainerProps>(
    (
        {
            className,
            filter,
            children,
            query,
            setQuery,
            searchResults,
            resultsLength = 0,
            align,
            isLoading = false,
            ...props
        },
        ref,
    ) => {
        const { element } = props
        const shift = align === 'end' ? 180 : align === 'center' ? 0 : undefined
        const trigger = element.trigger as string
        const triggerBehavior = getTriggerBehavior(trigger as string)
        const fixedPosition = triggerBehavior?.fixedPosition ?? false
        const fullWidth = triggerBehavior?.fullWidth ?? false
        const isEmpty = resultsLength === 0 && !isLoading

        return (
            <PlateElement as="span" data-slate-value={element.trigger + query} ref={ref} {...props}>
                <InlineCombobox
                    showTrigger
                    element={element}
                    setValue={setQuery}
                    trigger={trigger}
                    value={query}
                    filter={filter}
                >
                    <InlineComboboxInput resultsLength={resultsLength} />

                    <InlineComboboxContent
                        fixed
                        shift={fullWidth ? undefined : shift}
                        arrowPadding={16}
                        className={isEmpty ? typeaheadMenuWrapperHidden : ''}
                        lockPosition={fixedPosition}
                        fullWidth={fullWidth}
                    >
                        {searchResults}
                    </InlineComboboxContent>
                </InlineCombobox>

                {children}
            </PlateElement>
        )
    },
)
